import outgoingCss from "../../styles/Dashboard Styles/outgoing.module.scss";

function Incoming({ outgoingMessages }) {
  return (
    <div className={outgoingCss.outgoing}>
      <div className={outgoingCss.outgoingElements}>
        <div className={outgoingCss.outgoingContent}>
          <p>{outgoingMessages.message}</p>
        </div>
        <div className={outgoingCss.outgoingTime}>
          <p>{outgoingMessages.dateTime}</p>
        </div>
      </div>
    </div>
  );
}

export default Incoming;
